"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupStyling = exports.whitelabel = void 0;
const tslib_1 = require("tslib");
const hex_to_hsl_1 = tslib_1.__importDefault(require("hex-to-hsl"));
function whitelabel(key) {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const whitelabelData = window.whitelabelData;
    if (!whitelabelData) {
        return;
    }
    if (key === 'samknows_one_logo') {
        return whitelabelData.samknows_one_logo;
    }
    if (whitelabelData.samknows_one_site_data &&
        whitelabelData.samknows_one_site_data[key]) {
        return whitelabelData.samknows_one_site_data[key];
    }
    return undefined;
}
exports.whitelabel = whitelabel;
const properties = [
    ['--color-primary', 'colorPrimary'],
    ['--color-secondary', 'colorPrimary']
];
function setupStyling() {
    if (typeof document === 'undefined') {
        return;
    }
    // teardown before setup
    properties.forEach(([property]) => {
        document.documentElement.style.removeProperty(property);
    });
    const colorPrimaryHex = whitelabel('colorPrimary');
    if (!colorPrimaryHex) {
        return;
    }
    properties.forEach(([property, key]) => {
        const style = whitelabel(key);
        if (!style) {
            return;
        }
        document.documentElement.style.setProperty(property, style);
    });
    const hexToHsl = (0, hex_to_hsl_1.default)(colorPrimaryHex);
    const colorPrimaryHsl = `${hexToHsl[0]}, ${hexToHsl[1]}%, calc(${hexToHsl[2]}% - 5%)`;
    document.documentElement.style.setProperty('--color-primary-darker', `hsl(${colorPrimaryHsl})`);
}
exports.setupStyling = setupStyling;
//# sourceMappingURL=whitelabel.js.map